import { CHANGELOG_ENTRIES } from "data/changelog";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./ChangelogPage.css";

export default function ChangelogPage() {
  const { t, i18n } = useTranslation();

  const formatEntryDate = (isoDate: string) => {
    const [year, month, day] = isoDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    const activeLocale = i18n.language === "fr" ? "fr-CA" : "en-CA";
    return new Intl.DateTimeFormat(activeLocale, {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  };

  const timelineEntries = [...CHANGELOG_ENTRIES].sort((a, b) =>
    b.date.localeCompare(a.date)
  );

  return (
    <div className="page changelog-page">
      <div className="page-breadcrumb">
        <Link to="/">{t("home")}</Link>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">{t("changelogTimeline")}</span>
      </div>

      <div className="page-header">
        <h1>{t("changelogTimeline")}</h1>
        <Link to="/onboarding?step=1">
          <button className="edit-button">{t("backToOnboarding")}</button>
        </Link>
      </div>

      <section className="changelog-timeline" aria-label={t("latestUpdates")}>
        {timelineEntries.map((entry) => (
          <article className="changelog-item" key={entry.id}>
            <div className="changelog-item__card">
              <p className="changelog-item__date">
                {t("date")}: {formatEntryDate(entry.date)}
              </p>
              <ul>
                {entry.changeKeys.map((changeKey) => (
                  <li key={changeKey}>{t(changeKey)}</li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
